<template>
  <StackPageLayout @close="handleClose">
    <template #title>Edit Cashier </template>

    <div
      class="flex min-h-full flex-col rounded-lg bg-background p-3"
    >
      <CashierForm
        :cashier-id="cashierId"
        @submit="handleSubmit"
      />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import type { CashierFormOutput } from "@/forms/cashierForm"
import { updateCashier } from "@/services/cashiers/updateCashier"

const props = defineProps<{ cashierId: string }>()

const { startLoading, stopLoading } =
  usePageBlockingLoading()
const router = useRouter()

const handleClose = () =>
  router.push({ name: "settingsCashierIndex" })

const handleSubmit = async (params: CashierFormOutput) => {
  startLoading()
  try {
    await updateCashier(props.cashierId, params)
    toast.success("Cashier updated")
    router.push({ name: "settingsCashierIndex" })
  } catch {
    toast.error("Failed to update cashier")
  } finally {
    stopLoading()
  }
}
</script>
